import { render, staticRenderFns } from "./modal-update-username.vue?vue&type=template&id=3ffe3fc2&"
import script from "./modal-update-username.vue?vue&type=script&lang=js&"
export * from "./modal-update-username.vue?vue&type=script&lang=js&"
import style0 from "./modal-update-username.vue?vue&type=style&index=0&id=3ffe3fc2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports